// BeforeAftersViewer.jsx
import React from 'react'
import BeforeAfterSlider from './BeforeAfterSlider'

const BeforeAftersViewer = ({ beforeAfters }) => {
  if (!beforeAfters || beforeAfters.length === 0) return null

  return (
    <div className="before-afters-viewer">
      {beforeAfters.map((item) => (
        <BeforeAfterSlider key={item.id} item={item} />
      ))}
    </div>
  )
}

export default BeforeAftersViewer
